<pr-status-label
  [dense]="dense"
  [label]="status"
  [color]="statusColourMap[status]"
/>
